function makeSelectionPossible(){
  const customDropdowns = document.querySelectorAll('.set-products-list-item .product-options .custom-dropdown');

    customDropdowns.forEach(function (customDropdown) {
        const selectedElement = customDropdown.querySelector('.custom-dropdown-selected');
        const optionsElement = customDropdown.querySelector('.custom-dropdown-options');
        const select = customDropdown.nextElementSibling;
        const imageWrapper = customDropdown.closest('.set-products-list-item').querySelector('.image-wrapper');

        if (!selectedElement.hasAttribute('data-listener-added')) {
            selectedElement.addEventListener('click', function () {
                customDropdowns.forEach(function (dropdown) {
                    const otherOptionsElement = dropdown.querySelector('.custom-dropdown-options');
                    if (dropdown !== customDropdown && otherOptionsElement.style.display === 'block') {
                        otherOptionsElement.style.display = 'none';
                    }
                });
                optionsElement.style.display = optionsElement.style.display === 'block' ? 'none' : 'block';
            });
            selectedElement.setAttribute('data-listener-added', 'true');
        }

        const customOptions = customDropdown.querySelectorAll('.custom-option');
        customOptions.forEach(option => {
            if (!option.hasAttribute('data-listener-added')) {
                option.addEventListener('click', function () {
                    const variantValue = this.getAttribute('data-variant');
                    select.value = variantValue;
                    selectedElement.innerHTML = this.innerHTML;
                    optionsElement.style.display = 'none';

                    const featuredImg = this.getAttribute('data-featured-img');
                    const imageSrc = `//www.bananabeauty.it/cdn/shop/${featuredImg}`;

                    imageWrapper.querySelector('img').src = imageSrc;
                });
                option.setAttribute('data-listener-added', 'true');
            }
        });
    });
}

    // Update countAtCart
    function Update_cart_count() {
        jQuery.getJSON('/cart.js', function (cart) {
            if (window.cart_group_set) {
                let count = 0;
                let has_set_creator = false;
                cart.items.forEach(function (element) {
                    if (Object.keys(element.properties).toString().toLowerCase() != 'set_creator') {
                        count += element.quantity
                    } else {
                        has_set_creator = true;
                    }
                });
                if (has_set_creator) {
                    count += 1;
                }
                if (cart.item_count > 0) {
                    $('.cart-count-bubble').removeClass('cart__toggle--empty');
                } else {
                    $('.cart-count-bubble').addClass('cart__toggle--empty');
                }
                $('#cart-icon-bubble .cart-count-bubble span').html(count);

                $('#cart-icon-bubble .cart-count-bubble span').html(count);
            } else {
                if (cart.item_count > 0) {
                    $('.cart-count-bubble').removeClass('cart__toggle--empty');
                } else {
                    $('.cart-count-bubble').addClass('cart__toggle--empty');
                }
                $('#cart-icon-bubble .cart-count-bubble span').html(cart.item_count);

                $('#cart-icon-bubble .cart-count-bubble span').html(cart.item_count);
            }

        });
    }
    // Update CartDrawer
    function updateCartDrawer(open, upsell) {
        $('cart-drawer').addClass('active');
        $('cart-drawer').removeClass('is-empty');
        fetch('/cart?section_id=cart-drawer').then(function (response) {
            return response.text();

        }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            const cart = $(doc).find('cart-drawer')[0].innerHTML;
            $(document).find('cart-drawer')[0].innerHTML = cart;
            Update_cart_count();
        }).catch(function (err) {
            console.error('Something went wrong.', err);
        });
    }


let dontdoitTwice = false; // in case this function is called twice

function productSet() {
    // Open the popup for Farbe inside set
    $('.js-option-info-btn').on('click', function () {
        const image = $(this).attr('data-image');
        const popup = $('.js-options-info-popup');
        const popupImage = $('.js-options-info-popup img');
        popupImage.attr('src', image);
        if (popup[0].complete == true) {
            popup.addClass('open');
            $('body').addClass('custom-modal-open');
        } else {
            setTimeout(function () {
                popup.addClass('open');
                $('body').addClass('custom-modal-open');
            }, 500)
        }

    });
    // Close the popup for Farbe inside set
    $('.js-options-info-popup .options-info-popup-close').on('click', function () {
        $('.js-options-info-popup').removeClass('open');
        $('body').removeClass('custom-modal-open');
    });
    // Hide select Alert content 
    $('.product__errors__close').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.product__form__errors').removeClass('is-visible');
    });


    // Add set to cart
    $('.js-add-set').on('click', function (e) {
        e.preventDefault();
        const setVariants = $('.js-set-product-options select');
        const setAlertforSelect = $('.product__form__errors');
        let addToCart = true;
        let cartVariants = [];
        var numberOfNotSelectedVariants = 0;
        if(dontdoitTwice){
            return;
        }
        dontdoitTwice = true;
        setVariants.each(function () {
            const value = $(this).find(":selected").val();
            const product = $(this).find(":selected").attr('data-product');
            // const variant = $(this).find(":selected").attr('data-title');
            const variant = $(this).find(":selected").attr('data-variant');
            const variantAlert = $('.custom-dropdown');
            var properties = {
                // 'Liquid_Lipstick': 'Set'
            };
            const propertiy_name = $(this).find(":selected").attr('data-property-name');
            const propertiy_value = $(this).find(":selected").attr('data-property-value');
            properties[propertiy_name] = propertiy_value
            if (value != "") {
                if (cartVariants.length > 0) {
                    var variantExsits = false;
                    cartVariants.map(function (value, index) {
                        if (value.id === variant) {
                            cartVariants[index].quantity = cartVariants[index].quantity + 1;
                            variantExsits = true;
                        }
                        if ((index + 1) == cartVariants.length) {
                            if (!variantExsits) {
                                cartVariants.push({
                                    id: variant,
                                    quantity: 1,
                                    price: 10,
                                    final_price: 10,
                                    properties
                                });
                            }
                        }
                    })
                } else {
                    cartVariants.push({
                        id: variant,
                        quantity: 1,
                        price: 10,
                        final_price: 10,
                        properties
                    });
                }
                let property = `<input type="hidden" class="js-set-properties" name="properties[${product}]" value="${variant}">`
                $(this).closest('form.product__form').prepend(property);
                $(this).closest('.js-set-product-options').removeClass('error')
                $(variantAlert).closest('.js-set-product-options').removeClass('error')
                $(setAlertforSelect).addClass('is-visible')
            } else {
                numberOfNotSelectedVariants++;
                $(this).addClass('error')
                $(setAlertforSelect).removeClass('is-visible')
                $(variantAlert).addClass('error')
                addToCart = false;
            }

        })
        if (numberOfNotSelectedVariants > 0) {
            $(setAlertforSelect).addClass('is-visible')
        }
        if (addToCart) {
            // Start of Erstelle Dein Liquid Lipstick Set + 1
            if (document.querySelector('button.js-add-set[data-productid="8488977924420"]')) {
                cartVariants.push({
                    id: 42927021293722,
                    quantity: 1,
                    price: 10,
                    final_price: 10,
                    properties: {
                        'FreeLipstick': `Set`
                    }
                });
            }
            // End of Erstelle Dein Liquid Lipstick Set + 1

            let formData = {
                items: cartVariants
            };

            $(setAlertforSelect).removeClass('is-visible')

            fetch('/cart/add.js',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        errorMessage(response)
                        return;
                    }
                    dontdoitTwice = false; 
                    setTimeout(function () {
                        const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                        cartItems.upSellCart();
                        updateCartDrawer(true);
                    }, 500)
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            $('.js-set-properties').remove();
            $(this).closest('form.product__form').find('[data-cart-errors-container]').html(`<div class="errors">${theme.strings.set_error}<button type="button" class="product__errors__close" data-close-error>${theme.icons.closeSmall}</button></div>`)
            $(this).closest('form.product__form').find('[data-cart-errors-container]').addClass('is-visible')
        }
    })
}

(function () {
    // Your code to execute
    function initializeProductSet() {
       const swiperElement = document.querySelector('.setSwiper');
        if (swiperElement && swiperElement.offsetParent !== null) {
            productSet();
            setTimeout(function(){
              makeSelectionPossible();
            },1000);
    
            var swiperOneSlide = new Swiper(".setSwiper", {
                slidesPerView: 2,
                spaceBetween: 5,
                breakpoints: {
                    576: {
                        slidesPerView: 2.3,
                        spaceBetween: 10,
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                }
            });
        }
      
        productSet();
        if(document.querySelectorAll('modal-opener.relative')){
            document.querySelectorAll('modal-opener.relative').forEach(function (value, index) {
                value.addEventListener('click', function (click, iclick) {
                    const intervalId = setInterval(function () {
                        const swiperElement = document.querySelector('.setSwiper');
                        if (swiperElement && swiperElement.offsetParent !== null) {
                            clearInterval(intervalId);
                            productSet();
                            setTimeout(function(){
                              makeSelectionPossible();
                            },1000);
    
                            var swiperOneSlide = new Swiper(".setSwiper", {
                                slidesPerView: 2,
                                spaceBetween: 5,
                                breakpoints: {
                                    576: {
                                        slidesPerView: 2.3,
                                        spaceBetween: 10,
                                    },
                                },
                                navigation: {
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                },
                                pagination: {
                                    el: '.swiper-pagination',
                                    clickable: true,
                                }
                            });
                        }else{
                            setTimeout(function(){ // clear interval if it's not Set creator ,4s its just random timing
                              clearInterval(intervalId);
                            },4000);
                        }
                    }, 500);
                });
            });
        }
    }

    // Attach to DOMContentLoaded or execute immediately
    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', initializeProductSet)
        : initializeProductSet();
})();
